import gql from 'graphql-tag'

const getLoyaltyAchievementBadges = schema => gql`query getLoyaltyAchievementBadges($isSpanish: Boolean!) {
    ${schema}_bll_achievement_badge__c (order_by: {bll_sequence_order__c: asc}) {
        id
        name
        sfid
        bll_active__c
        bll_badge_icon_url__c @skip(if: $isSpanish)
        bll_badge_icon_url__c : bll_spanish_badge_icon_url__c @include(if: $isSpanish)
        bll_type__c
        bll_achievement_badge_code__c
        bll_achievement_badge_sub_title__c  @skip(if: $isSpanish)
        bll_achievement_badge_sub_title__c : bll_achievement_badge_sub_title_spanish__c @include(if: $isSpanish)
        bll_achievement_badge_title__c  @skip(if: $isSpanish)
        bll_achievement_badge_title__c : bll_achievement_badge_title_spanish__c @include(if :$isSpanish)
        bll_sequence_order__c
    }
  }`

export default getLoyaltyAchievementBadges

